import { Service } from '@angular/core';
import { from, Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';

import { TranslationRepository } from '@core/i18n/domain/interfaces/translation.interface';
import { Language } from '@core/i18n/domain/language';
import { ITranslationsApiResponse } from '@core/i18n/domain/translation.types';
import { preloadLocalTranslations } from '@core/i18n/data/translations.dictionary';

/**
 * MockTranslationRepository — the DEFAULT source.
 *
 * Serves the bundled local dictionary as if it came from the API, so the
 * whole i18n pipeline (merge → flatten → cache → facade signals) runs
 * end-to-end with no backend. A tiny delay emulates network latency so the
 * splash "loading depends on TranslationFacade" gate is observable.
 *
 * Only ever active when `I18N_CONFIG.useMock` is true (never in production —
 * see `DEFAULT_I18N_CONFIG`), so awaiting the lazy per-language dictionary
 * chunk here (rev. 9 perf pass, see `translations.dictionary.ts`) carries
 * zero production risk; it just mirrors what a real API call already does.
 */
@Service({ autoProvided: false })
export class MockTranslationRepository extends TranslationRepository {
  override getTranslations(lang: Language): Observable<ITranslationsApiResponse> {
    return from(preloadLocalTranslations(lang)).pipe(
      delay(450),
      map((data) => ({ status: true, message: null, data })),
    );
  }
}
